// extracted by mini-css-extract-plugin
export var quillEditor = "_in-1";
export var variable = "_in-0";